// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sticky Circular Help Button */
.EVx_h6l_U9XxYzY448fy {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
    background-image: linear-gradient(var(--text-color), var(--text-color));
    color: var(--accent-color);
    border: none;
    border-radius: 50%;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    border: 2px double var(--border-color);
  }
  
  /* Help Popup Overlay */
  .LLAvqjHb_O9mutJTrRDO {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  /* Help Popup */
  .mkEthm15OMOCbwY5c7Uk {
    background-color: #005293;
    padding: 20px;
    width: 90%;
    max-width: 600px;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    text-align: center;
    position: relative;
    color: #FECB00;
  }
  
  /* Close Button */
  .xjZ3p7Fbybxi_837bYjC {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    color: #005293;
    background-color: #FECB00;
    border: 2px double var(--border-color);
  }
  
  /* Video Container */
  .ZDGB188iMobblzbidmHO {
    width: 100%;
    height: 300px;
    margin-top: 20px;
    border-radius: 8px;
    overflow: hidden;
  }
  `, "",{"version":3,"sources":["webpack://./src/HelpPopup.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uEAAuE;IACvE,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wCAAwC;IACxC,aAAa;IACb,sCAAsC;EACxC;;EAEA,uBAAuB;EACvB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA,eAAe;EACf;IACE,yBAAyB;IACzB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":["/* Sticky Circular Help Button */\n.help-button {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    width: 50px;\n    height: 50px;\n    background-image: linear-gradient(var(--text-color), var(--text-color));\n    color: var(--accent-color);\n    border: none;\n    border-radius: 50%;\n    font-size: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n    z-index: 1000;\n    border: 2px double var(--border-color);\n  }\n  \n  /* Help Popup Overlay */\n  .popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n  }\n  \n  /* Help Popup */\n  .popup {\n    background-color: #005293;\n    padding: 20px;\n    width: 90%;\n    max-width: 600px;\n    border-radius: 8px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    position: relative;\n    color: #FECB00;\n  }\n  \n  /* Close Button */\n  .close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    font-weight: bold;\n    cursor: pointer;\n    color: #005293;\n    background-color: #FECB00;\n    border: 2px double var(--border-color);\n  }\n  \n  /* Video Container */\n  .video-container {\n    width: 100%;\n    height: 300px;\n    margin-top: 20px;\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"help-button": `EVx_h6l_U9XxYzY448fy`,
	"popup-overlay": `LLAvqjHb_O9mutJTrRDO`,
	"popup": `mkEthm15OMOCbwY5c7Uk`,
	"close-button": `xjZ3p7Fbybxi_837bYjC`,
	"video-container": `ZDGB188iMobblzbidmHO`
};
export default ___CSS_LOADER_EXPORT___;
